import { useApp } from "@/context/AppContext";

export function PolicyBadge({ id }) {
  const { openSource } = useApp();
  if (!id) return null;
  return (
    <button data-testid={`policy-badge-${id}`} onClick={(e) => { e.stopPropagation(); openSource({ policy_id: id }); }}
      className="inline-flex text-[10px] num px-1.5 py-0.5 rounded border border-emerald-500/40 text-emerald-700 bg-emerald-500/5 hover:bg-emerald-500/15 transition-colors whitespace-nowrap">
      {id}
    </button>
  );
}

export function RuleBadge({ id }) {
  const { openSource } = useApp();
  if (!id) return null;
  return (
    <button data-testid={`rule-badge-${id}`} onClick={(e) => { e.stopPropagation(); openSource({ rule_id: id }); }}
      className="inline-flex text-[10px] num px-1.5 py-0.5 rounded border border-indigo-400/40 text-indigo-700 bg-indigo-500/5 hover:bg-indigo-500/15 transition-colors whitespace-nowrap">
      {id}
    </button>
  );
}

export function EvidenceChip({ ev, task }) {
  const { openSource } = useApp();
  const [kind, key] = ev.split(":");
  const open = () => {
    if (kind === "calc") openSource({ metric: task.metrics[key], metrics: task.metrics });
    if (kind === "fact") { const f = task.facts.find((x) => x.key === key); if (f) openSource({ doc_id: f.doc_id, page: f.page, snippet: f.snippet }); }
  };
  const clickable = kind === "calc" || kind === "fact";
  return (
    <button data-testid={`evidence-chip-${ev.replace(":", "-")}`} disabled={!clickable} onClick={open}
      className={`text-[10px] num px-1.5 py-0.5 rounded border transition-colors ${kind === "calc" ? "border-violet-500/40 text-violet-700 hover:bg-violet-500/10" : kind === "fact" ? "border-sky-500/40 text-sky-700 hover:bg-sky-600/10" : "border-slate-300 text-slate-600"}`}>
      {ev}
    </button>
  );
}
